import gallery1 from "../images/gallery-1.png";
import gallery2 from "../images/gallery-2.png";
import gallery3 from "../images/gallery-3.png";
import gallery4 from "../images/gallery-4.png";
import gallery5 from "../images/gallery-5.png";
import gallery6 from "../images/gallery-6.png";

export default function Gallery() {
  const images = [
    {
      url: gallery1,
      caption: "Elegantný dámsky strih",
    },
    {
      url: gallery2,
      caption: "Balayage technika",
    },
    {
      url: gallery3,
      caption: "Moderný pánsky strih",
    },
    {
      url: gallery4,
      caption: "Melír s tónovaním",
    },
    {
      url: gallery5,
      caption: "Profesionálne farbenie",
    },
    {
      url: gallery6,
      caption: "Detské strihanie",
    },
  ];

  return (
    <section id="galeria" className="py-20 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Galéria našej práce
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Pozrite si ukážky našich realizácií a presvedčte sa o kvalite našich služieb
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300"
            >
              <div className="w-full h-96">
                <img
                  src={image.url}
                  alt={image.caption}
                  loading="lazy"
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>

              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <p className="text-white font-medium text-lg p-6">
                  {image.caption}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
